const searchForm = document.querySelector('.search-form > form');
const searchFormInput = document.querySelector('.search-form > form > input');

export default function initSearchForm() {
  if(searchForm) {
    searchForm.addEventListener('submit', function (e) {
      if (searchFormInput.value === '') {
        e.preventDefault();
      }
    });
  }
}
